module.exports = __webpack_public_path__ + "static/media/12-1.d67e0e4b.jpg";